/**
 * Converts arbitrary text into a lowercase, hyphen-separated slug.
 * @param text - The text to slugify
 * @returns A kebab-case slug, or an empty string if `text` has no alphanumeric characters
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
